module.exports = __webpack_public_path__ + "static/media/chachi.a5131630.png";


//////////////////
// WEBPACK FOOTER
// ./src/chachi.png
// module id = 179
// module chunks = 0